import { defineComponent } from "vue";
export default defineComponent({
    name: 'SymbolImageZoomArrows',
    props: {
        preventAnimation: {
            type: Boolean,
            default: false
        },
        backgroundColor: {
            type: String,
            default: 'transparent'
        },
        strokeColor: {
            type: String,
            default: '#444444'
        }
    },
    computed: {
        cssClasses() {
            const classes = [];
            if (this.preventAnimation) {
                classes.push('preventAnimation');
            }
            return classes.join(' ');
        }
    }
});
